import axios, {isCancel} from 'axios';
import qs from 'qs';
import {logout, makeSign} from "./make";
import {useUserStore} from "@/store/module/user";
import {ElMessage} from "element-plus";
import router from "@/router";

const filter = function (inObject) {
    const sortedJson = {};
    const sortedKeys = Object.keys(inObject).sort();
    for (let i = 0; i < sortedKeys.length; i++) {
        sortedJson[sortedKeys[i]] = inObject[sortedKeys[i]]
    }
    return sortedJson;
}
const cacheRequest = {};

function abortCacheRequest(reqKey) {
    if (cacheRequest[reqKey]) {
        // 通过AbortController实例上的abort来终止请求
        cacheRequest[reqKey].abort()
        delete cacheRequest[reqKey]
    }
}

const service = axios.create({
    baseURL: process.env.VUE_APP_ADMIN_API_BASE_URL,
    timeout: 5000,
    withCredentials:true,
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
    },
});
service.interceptors.request.use(
    config => {
        const reqKey = `${config.url}&${config.method}`
        abortCacheRequest(reqKey);
        const controller = new AbortController()
        config.signal = controller.signal
        cacheRequest[reqKey] = controller
        if (config.method === 'get') {
            config.params = config.params || {}
            config.params = makeSign(config.params)
        } else if (config.method === 'post') {
            if (config.data instanceof FormData) {
                config.data = makeSign(config.data)
            } else {
                config.data = config.data || {}
                config.data = makeSign(config.data) // 参数签名
                config.data = qs.stringify(filter(config.data)) // 转form表单
            }
        }
        const userInfoStore = useUserStore()
        config.headers.Authorization = 'Bearer '+userInfoStore.token
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
)

service.interceptors.response.use(
    response => {
        delete cacheRequest[`${response.config.url}&${response.config.method}`]
        if (response.status === 200) {
            if (response.headers['content-disposition'] && !response?.data?.code) {
                const disposition = response.headers['content-disposition'];
                let fileName = decodeURI(escape(disposition.split('filename=')[1].split(';')[0]))

                const blob = new Blob([response.data], {type: response.headers['content-type']});
                const downloadElement = document.createElement('a');
                const href = window.URL.createObjectURL(blob); // 创建下载的链接
                downloadElement.href = href;
                downloadElement.download = fileName; // 下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); // 点击下载
                document.body.removeChild(downloadElement); // 下载完成移除元素
                window.URL.revokeObjectURL(href); // 释放掉blob对象
                return response.data
            }
            if (response.data.code !== 200) {
                ElMessage({ message: response.data.message, grouping: true, type: 'error' })
                return Promise.reject(response.data.message)
            }

            return response.data;
        }
    },
    error => {
        if (axios.isCancel(error) || isCancel(error)) {
            console.log('Request canceled');
            return Promise.reject('canceled'); // 你可以根据需要修改这里的处理方式，例如返回一个特定的错误对象等。
        }
        const {response} = error;
        if (response.status === 401) {
            logout()
            //登录失效
            return router.push('/login')
        }
        ElMessage({ message: "网络请求失败", grouping: true, type: 'error' })
        return Promise.reject('请求失败');
    }
)

export default service;
